import React from 'react';

function Icon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="none" viewBox="0 0 15 15">
            <path
                fill="#FCB413"
                d="M12.021 8.723a.656.656 0 00-.655.655v.25l-.97-.97a1.829 1.829 0 00-2.577 0l-.459.458L5.735 7.49a1.868 1.868 0 00-2.577 0l-.97.97V4.79a.656.656 0 01.656-.656h4.589a.656.656 0 100-1.311h-4.59A1.967 1.967 0 00.878 4.789v7.867a1.967 1.967 0 001.967 1.967h7.866a1.967 1.967 0 001.967-1.967V9.378a.655.655 0 00-.656-.655zm-9.177 4.589a.656.656 0 01-.656-.656v-2.34L4.09 8.415a.518.518 0 01.715 0l2.078 2.078L9.7 13.312H2.844zm8.522-.656a.583.583 0 01-.118.348l-2.957-2.97.46-.459a.505.505 0 01.72 0l1.895 1.908v1.173zm3.088-9.643l-1.967-1.967A.655.655 0 0012.27.91a.655.655 0 00-.499 0 .655.655 0 00-.216.137L9.589 3.013a.658.658 0 10.931.93l.846-.851v3.664a.656.656 0 001.311 0V3.092l.846.852a.656.656 0 001.074-.214.655.655 0 00-.143-.717z"
            ></path>
        </svg>
    );
}

export default Icon;
